import { useCallback } from 'react';
import { useQueryState, parseAsString } from 'nuqs';

const CONVERSATION_ID_PARAM = 'conversationId';

export const useConversationIdParam = () => {
  const [conversationId, setQueryParam] = useQueryState(
    CONVERSATION_ID_PARAM,
    parseAsString.withOptions({ history: 'replace' }),
  );

  const setConversationId = useCallback(
    (id?: string) => {
      void setQueryParam(id ?? null);
    },
    [setQueryParam],
  );

  return [conversationId ?? undefined, setConversationId] as const;
};
